import { EMPTY_LIST } from '../../../../constants/common'
import { useInitData, useUserData } from '../../../../hooks'
import { isCalendarSectionAvailable } from '../../../../utils/calendar'
import { useAppointments } from '../../../Appointment'

import { getEmailProfileAppointmentsParams } from './useEmailProfileAppointments.utils'

// The appointments made from this thread (CAL-02 §7.10); none while the read is pending or failed
export function useEmailProfileAppointments({ isEnabled, messages }) {
  const { availableSections } = useInitData()

  const userData = useUserData()

  const isAppointmentAvailable = isCalendarSectionAvailable({
    availableSections,
    role: userData?.role,
  })

  const { data, handleReload } = useAppointments(
    getEmailProfileAppointmentsParams({
      isAvailable: isEnabled && isAppointmentAvailable,
      threadUuid: messages?.[0]?.email_thread_uuid,
    })
  )

  return {
    appointments: data?.items ?? EMPTY_LIST,
    handleReloadAppointments: handleReload,
    isAppointmentAvailable,
  }
}
